
const appraiserCountyFiles = {
  add: appraiserId => `/appraiser-county-files/appraisers/${appraiserId}`,
  delete: fileId => `/appraiser-county-files/${fileId}`,
  getList: appraiserId => `/appraiser-county-files/appraisers/${appraiserId}`,
  getFileDownload: fileId => `/appraiser-county-files/${fileId}/download`,
  getFileView: fileId => `/appraiser-county-files/${fileId}/download`,
};

export default appraiserCountyFiles;
